import { BankDetail, UpiAppDetail, CreditCardDetail, BankCategory } from '../types';

export const banks: Record<string, BankDetail> = {
  // == Public Sector Banks (India) ==
  'state-bank-of-india-in': {
    id: 'sbi',
    slug: 'state-bank-of-india-in',
    name: 'State Bank of India',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'punjab-national-bank-in': {
    id: 'pnb',
    slug: 'punjab-national-bank-in',
    name: 'Punjab National Bank',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'bank-of-baroda-in': {
    id: 'bob',
    slug: 'bank-of-baroda-in',
    name: 'Bank of Baroda',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'canara-bank-in': {
    id: 'canara',
    slug: 'canara-bank-in',
    name: 'Canara Bank',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'bank-of-india-in': {
    id: 'boi',
    slug: 'bank-of-india-in',
    name: 'Bank of India',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'union-bank-of-india-in': {
    id: 'union',
    slug: 'union-bank-of-india-in',
    name: 'Union Bank of India',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'indian-bank-in': {
    id: 'indian',
    slug: 'indian-bank-in',
    name: 'Indian Bank',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'central-bank-of-india-in': {
    id: 'cbi',
    slug: 'central-bank-of-india-in',
    name: 'Central Bank of India',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'uco-bank-in': {
    id: 'uco',
    slug: 'uco-bank-in',
    name: 'UCO Bank',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'bank-of-maharashtra-in': {
      id: 'bom',
      slug: 'bank-of-maharashtra-in',
      name: 'Bank of Maharashtra',
      category: BankCategory.PUBLIC,
      country: 'IN',
      charges: [],
  },
  'indian-overseas-bank-in': {
    id: 'iob',
    slug: 'indian-overseas-bank-in',
    name: 'Indian Overseas Bank',
    category: BankCategory.PUBLIC,
    country: 'IN',
    charges: [],
  },
  'punjab-sind-bank-in': {
      id: 'psb',
      slug: 'punjab-sind-bank-in',
      name: 'Punjab & Sind Bank',
      category: BankCategory.PUBLIC,
      country: 'IN',
      charges: [],
  },


  // == Private Sector Banks (India) ==
  'hdfc-bank-in': {
    id: 'hdfc',
    slug: 'hdfc-bank-in',
    name: 'HDFC Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
  'icici-bank-in': {
    id: 'icici',
    slug: 'icici-bank-in',
    name: 'ICICI Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
   'axis-bank-in': {
    id: 'axis',
    slug: 'axis-bank-in',
    name: 'Axis Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
   'kotak-mahindra-bank-in': {
    id: 'kotak',
    slug: 'kotak-mahindra-bank-in',
    name: 'Kotak Mahindra Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
   'yes-bank-in': {
    id: 'yes',
    slug: 'yes-bank-in',
    name: 'Yes Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
  'idfc-first-bank-in': {
    id: 'idfc',
    slug: 'idfc-first-bank-in',
    name: 'IDFC FIRST Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
  'indusind-bank-in': {
    id: 'indusind',
    slug: 'indusind-bank-in',
    name: 'IndusInd Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
  'federal-bank-in': {
    id: 'federal',
    slug: 'federal-bank-in',
    name: 'Federal Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
  'rbl-bank-in': {
    id: 'rbl',
    slug: 'rbl-bank-in',
    name: 'RBL Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
  'bandhan-bank-in': {
    id: 'bandhan',
    slug: 'bandhan-bank-in',
    name: 'Bandhan Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
  'csb-bank-in': {
      id: 'csb',
      slug: 'csb-bank-in',
      name: 'CSB Bank',
      category: BankCategory.PRIVATE,
      country: 'IN',
      charges: [],
  },
  'city-union-bank-in': {
    id: 'cub',
    slug: 'city-union-bank-in',
    name: 'City Union Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
  'dcb-bank-in': {
      id: 'dcb',
      slug: 'dcb-bank-in',
      name: 'DCB Bank',
      category: BankCategory.PRIVATE,
      country: 'IN',
      charges: [],
  },
  'dhanlaxmi-bank-in': {
      id: 'dhanlaxmi',
      slug: 'dhanlaxmi-bank-in',
      name: 'Dhanlaxmi Bank',
      category: BankCategory.PRIVATE,
      country: 'IN',
      charges: [],
  },
  'jammu-kashmir-bank-in': {
      id: 'jkb',
      slug: 'jammu-kashmir-bank-in',
      name: 'Jammu & Kashmir Bank',
      category: BankCategory.PRIVATE,
      country: 'IN',
      charges: [],
  },
  'karnataka-bank-in': {
      id: 'kbl',
      slug: 'karnataka-bank-in',
      name: 'Karnataka Bank',
      category: BankCategory.PRIVATE,
      country: 'IN',
      charges: [],
  },
  'karur-vysya-bank-in': {
      id: 'kvb',
      slug: 'karur-vysya-bank-in',
      name: 'Karur Vysya Bank',
      category: BankCategory.PRIVATE,
      country: 'IN',
      charges: [],
  },
  'south-indian-bank-in': {
      id: 'sib',
      slug: 'south-indian-bank-in',
      name: 'South Indian Bank',
      category: BankCategory.PRIVATE,
      country: 'IN',
      charges: [],
  },
  'idbi-bank-in': {
    id: 'idbi',
    slug: 'idbi-bank-in',
    name: 'IDBI Bank',
    category: BankCategory.PRIVATE,
    country: 'IN',
    charges: [],
  },
  'nainital-bank-in': {
      id: 'nainital',
      slug: 'nainital-bank-in',
      name: 'Nainital Bank',
      category: BankCategory.PRIVATE,
      country: 'IN',
      charges: [],
  },
  'tamilnad-mercantile-bank-in': {
      id: 'tmb',
      slug: 'tamilnad-mercantile-bank-in',
      name: 'Tamilnad Mercantile Bank',
      category: BankCategory.PRIVATE,
      country: 'IN',
      charges: [],
  },
  
  // == Small Finance Banks (India) ==
  'au-small-finance-bank-in': {
    id: 'au',
    slug: 'au-small-finance-bank-in',
    name: 'AU Small Finance Bank',
    category: BankCategory.SMALL_FINANCE,
    country: 'IN',
    charges: [],
  },
  'equitas-small-finance-bank-in': {
    id: 'equitas',
    slug: 'equitas-small-finance-bank-in',
    name: 'Equitas Small Finance Bank',
    category: BankCategory.SMALL_FINANCE,
    country: 'IN',
    charges: [],
  },
  'ujjivan-small-finance-bank-in': {
    id: 'ujjivan',
    slug: 'ujjivan-small-finance-bank-in',
    name: 'Ujjivan Small Finance Bank',
    category: BankCategory.SMALL_FINANCE,
    country: 'IN',
    charges: [],
  },
  'unity-small-finance-bank-in': {
    id: 'unity',
    slug: 'unity-small-finance-bank-in',
    name: 'Unity Small Finance Bank',
    category: BankCategory.SMALL_FINANCE,
    country: 'IN',
    charges: [],
  },
  'jana-small-finance-bank-in': {
    id: 'jana',
    slug: 'jana-small-finance-bank-in',
    name: 'Jana Small Finance Bank',
    category: BankCategory.SMALL_FINANCE,
    country: 'IN',
    charges: [],
  },
  'esaf-small-finance-bank-in': {
      id: 'esaf-sfb',
      slug: 'esaf-small-finance-bank-in',
      name: 'ESAF Small Finance Bank',
      category: BankCategory.SMALL_FINANCE,
      country: 'IN',
      charges: [],
  },
  'suryoday-small-finance-bank-in': {
      id: 'suryoday-sfb',
      slug: 'suryoday-small-finance-bank-in',
      name: 'Suryoday Small Finance Bank',
      category: BankCategory.SMALL_FINANCE,
      country: 'IN',
      charges: [],
  },
  'capital-small-finance-bank-in': {
    id: 'capital-sfb',
    slug: 'capital-small-finance-bank-in',
    name: 'Capital Small Finance Bank',
    category: BankCategory.SMALL_FINANCE,
    country: 'IN',
    charges: [],
  },
  'fincare-small-finance-bank-in': {
      id: 'fincare-sfb',
      slug: 'fincare-small-finance-bank-in',
      name: 'Fincare Small Finance Bank',
      category: BankCategory.SMALL_FINANCE,
      country: 'IN',
      charges: [],
  },
  'north-east-small-finance-bank-in': {
      id: 'nesfb',
      slug: 'north-east-small-finance-bank-in',
      name: 'North East Small Finance Bank',
      category: BankCategory.SMALL_FINANCE,
      country: 'IN',
      charges: [],
  },
  'shivalik-small-finance-bank-in': {
      id: 'shivalik-sfb',
      slug: 'shivalik-small-finance-bank-in',
      name: 'Shivalik Small Finance Bank',
      category: BankCategory.SMALL_FINANCE,
      country: 'IN',
      charges: [],
  },
  
  // == Payments Banks (India) ==
  'airtel-payments-bank-in': {
    id: 'airtel-pb',
    slug: 'airtel-payments-bank-in',
    name: 'Airtel Payments Bank',
    category: BankCategory.PAYMENTS,
    country: 'IN',
    charges: [],
  },
  'fino-payments-bank-in': {
    id: 'fino-pb',
    slug: 'fino-payments-bank-in',
    name: 'Fino Payments Bank',
    category: BankCategory.PAYMENTS,
    country: 'IN',
    charges: [],
  },
  'india-post-payments-bank-in': {
    id: 'ippb',
    slug: 'india-post-payments-bank-in',
    name: 'India Post Payments Bank',
    category: BankCategory.PAYMENTS,
    country: 'IN',
    charges: [],
  },
  'paytm-payments-bank-in': {
    id: 'paytm-pb',
    slug: 'paytm-payments-bank-in',
    name: 'Paytm Payments Bank',
    category: BankCategory.PAYMENTS,
    country: 'IN',
    charges: [],
  },
  'jio-payments-bank-in': {
      id: 'jio-pb',
      slug: 'jio-payments-bank-in',
      name: 'Jio Payments Bank',
      category: BankCategory.PAYMENTS,
      country: 'IN',
      charges: [],
  },
  'nsdl-payments-bank-in': {
      id: 'nsdl-pb',
      slug: 'nsdl-payments-bank-in',
      name: 'NSDL Payments Bank',
      category: BankCategory.PAYMENTS,
      country: 'IN',
      charges: [],
  },

   // == Foreign Banks (India) ==
  'citibank-in': {
    id: 'citi-in',
    slug: 'citibank-in',
    name: 'Citibank N.A. (India)',
    category: BankCategory.FOREIGN,
    country: 'IN',
    charges: [],
  },
   'hsbc-bank-in': {
    id: 'hsbc-in',
    slug: 'hsbc-bank-in',
    name: 'HSBC Bank (India)',
    category: BankCategory.FOREIGN,
    country: 'IN',
    charges: [],
  },
  'standard-chartered-bank-in': {
    id: 'sc-in',
    slug: 'standard-chartered-bank-in',
    name: 'Standard Chartered Bank (India)',
    category: BankCategory.FOREIGN,
    country: 'IN',
    charges: [],
  },
  'dbs-bank-in': {
    id: 'dbs-in',
    slug: 'dbs-bank-in',
    name: 'DBS Bank (India)',
    category: BankCategory.FOREIGN,
    country: 'IN',
    charges: [],
  },
  'deutsche-bank-in': {
      id: 'deutsche-in',
      slug: 'deutsche-bank-in',
      name: 'Deutsche Bank (India)',
      category: BankCategory.FOREIGN,
      country: 'IN',
      charges: [],
  },
  'barclays-bank-in': {
      id: 'barclays-in',
      slug: 'barclays-bank-in',
      name: 'Barclays Bank (India)',
      category: BankCategory.FOREIGN,
      country: 'IN',
      charges: [],
  },
  'bank-of-america-in': {
    id: 'boa-in',
    slug: 'bank-of-america-in',
    name: 'Bank of America (India)',
    category: BankCategory.FOREIGN,
    country: 'IN',
    charges: [],
  },
  'bnp-paribas-in': {
      id: 'bnp-in',
      slug: 'bnp-paribas-in',
      name: 'BNP Paribas (India)',
      category: BankCategory.FOREIGN,
      country: 'IN',
      charges: [],
  },
  'jp-morgan-chase-bank-in': {
      id: 'jpmc-in',
      slug: 'jp-morgan-chase-bank-in',
      name: 'JP Morgan Chase Bank (India)',
      category: BankCategory.FOREIGN,
      country: 'IN',
      charges: [],
  },
  'doha-bank-in': {
      id: 'doha-in',
      slug: 'doha-bank-in',
      name: 'Doha Bank (India)',
      category: BankCategory.FOREIGN,
      country: 'IN',
      charges: [],
  },
  'qatar-national-bank-in': {
      id: 'qnb-in',
      slug: 'qatar-national-bank-in',
      name: 'Qatar National Bank (India)',
      category: BankCategory.FOREIGN,
      country: 'IN',
      charges: [],
  },
  'abu-dhabi-commercial-bank-in': {
      id: 'adcb-in',
      slug: 'abu-dhabi-commercial-bank-in',
      name: 'Abu Dhabi Commercial Bank (India)',
      category: BankCategory.FOREIGN,
      country: 'IN',
      charges: [],
  },

  // == Regional Rural Banks (India) ==
  'karnataka-gramin-bank-in': {
    id: 'kgb',
    slug: 'karnataka-gramin-bank-in',
    name: 'Karnataka Gramin Bank',
    category: BankCategory.RRB,
    country: 'IN',
    charges: [],
  },
  'baroda-up-bank-in': {
    id: 'bupb',
    slug: 'baroda-up-bank-in',
    name: 'Baroda UP Bank',
    category: BankCategory.RRB,
    country: 'IN',
    charges: [],
  },
  'aryavart-bank-in': {
    id: 'aryavart',
    slug: 'aryavart-bank-in',
    name: 'Aryavart Bank',
    category: BankCategory.RRB,
    country: 'IN',
    charges: [],
  },
  'kerala-gramin-bank-in': {
      id: 'kerala-gb',
      slug: 'kerala-gramin-bank-in',
      name: 'Kerala Gramin Bank',
      category: BankCategory.RRB,
      country: 'IN',
      charges: [],
  },

  // == US Banks (Traditional) ==
  'bank-of-america-us': {
    id: 'boa-us',
    slug: 'bank-of-america-us',
    name: 'Bank of America',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'jpmorgan-chase-us': {
    id: 'chase-us',
    slug: 'jpmorgan-chase-us',
    name: 'JPMorgan Chase',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'wells-fargo-us': {
    id: 'wellsfargo-us',
    slug: 'wells-fargo-us',
    name: 'Wells Fargo',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'citibank-us': {
    id: 'citi-us',
    slug: 'citibank-us',
    name: 'Citibank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'us-bank-us': {
    id: 'us-bank-us',
    slug: 'us-bank-us',
    name: 'U.S. Bank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'pnc-bank-us': {
    id: 'pnc-us',
    slug: 'pnc-bank-us',
    name: 'PNC Bank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'truist-bank-us': {
    id: 'truist-us',
    slug: 'truist-bank-us',
    name: 'Truist Bank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'td-bank-us': {
    id: 'td-bank-us',
    slug: 'td-bank-us',
    name: 'TD Bank (US)',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'regions-bank-us': {
    id: 'regions-us',
    slug: 'regions-bank-us',
    name: 'Regions Bank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'huntington-bank-us': {
    id: 'huntington-us',
    slug: 'huntington-bank-us',
    name: 'Huntington Bank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },

  // == US Banks (Online/Neobanks) ==
  'ally-bank-us': {
    id: 'ally-us',
    slug: 'ally-bank-us',
    name: 'Ally Bank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'capital-one-360-us': {
    id: 'cap1-360-us',
    slug: 'capital-one-360-us',
    name: 'Capital One 360',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'chime-us': {
    id: 'chime-us',
    slug: 'chime-us',
    name: 'Chime',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'sofi-us': {
    id: 'sofi-us',
    slug: 'sofi-us',
    name: 'SoFi',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'varo-bank-us': {
    id: 'varo-us',
    slug: 'varo-bank-us',
    name: 'Varo Bank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'discover-bank-us': {
    id: 'discover-bank-us',
    slug: 'discover-bank-us',
    name: 'Discover Bank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'axos-bank-us': {
    id: 'axos-us',
    slug: 'axos-bank-us',
    name: 'Axos Bank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'revolut-us': {
    id: 'revolut-us',
    slug: 'revolut-us',
    name: 'Revolut (US)',
    category: BankCategory.PAYMENT_SERVICE,
    country: 'US',
    charges: [],
  },
  'current-us': {
    id: 'current-us',
    slug: 'current-us',
    name: 'Current',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },
  'gobank-us': {
    id: 'gobank-us',
    slug: 'gobank-us',
    name: 'GoBank',
    category: BankCategory.PRIVATE,
    country: 'US',
    charges: [],
  },

  // == UK Banks ==
  'barclays-bank-gb': { id: 'barclays-gb', slug: 'barclays-bank-gb', name: 'Barclays Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'hsbc-uk-gb': { id: 'hsbc-uk-gb', slug: 'hsbc-uk-gb', name: 'HSBC UK', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'lloyds-bank-gb': { id: 'lloyds-gb', slug: 'lloyds-bank-gb', name: 'Lloyds Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'natwest-bank-gb': { id: 'natwest-gb', slug: 'natwest-bank-gb', name: 'NatWest Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'royal-bank-of-scotland-gb': { id: 'rbs-gb', slug: 'royal-bank-of-scotland-gb', name: 'Royal Bank of Scotland (RBS)', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'santander-uk-gb': { id: 'santander-gb', slug: 'santander-uk-gb', name: 'Santander UK', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'halifax-bank-gb': { id: 'halifax-gb', slug: 'halifax-bank-gb', name: 'Halifax Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'tsb-bank-gb': { id: 'tsb-gb', slug: 'tsb-bank-gb', name: 'TSB Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'virgin-money-uk-gb': { id: 'virgin-money-gb', slug: 'virgin-money-uk-gb', name: 'Virgin Money UK', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'metro-bank-gb': { id: 'metro-gb', slug: 'metro-bank-gb', name: 'Metro Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'co-operative-bank-gb': { id: 'co-op-gb', slug: 'co-operative-bank-gb', name: 'Co-operative Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'nationwide-building-society-gb': { id: 'nationwide-gb', slug: 'nationwide-building-society-gb', name: 'Nationwide Building Society', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'tesco-bank-gb': { id: 'tesco-bank-gb', slug: 'tesco-bank-gb', name: 'Tesco Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'sainsburys-bank-gb': { id: 'sainsburys-bank-gb', slug: 'sainsburys-bank-gb', name: 'Sainsbury’s Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'standard-chartered-uk-gb': { id: 'sc-uk-gb', slug: 'standard-chartered-uk-gb', name: 'Standard Chartered UK', category: BankCategory.FOREIGN, country: 'GB', charges: [] },
  'citibank-uk-gb': { id: 'citi-uk-gb', slug: 'citibank-uk-gb', name: 'Citibank UK', category: BankCategory.FOREIGN, country: 'GB', charges: [] },
  'jpmorgan-chase-uk-gb': { id: 'chase-uk-gb', slug: 'jpmorgan-chase-uk-gb', name: 'JPMorgan Chase UK (Chase UK)', category: BankCategory.FOREIGN, country: 'GB', charges: [] },
  'icici-bank-uk-gb': { id: 'icici-uk-gb', slug: 'icici-bank-uk-gb', name: 'ICICI Bank UK', category: BankCategory.FOREIGN, country: 'GB', charges: [] },
  'state-bank-of-india-uk-gb': { id: 'sbi-uk-gb', slug: 'state-bank-of-india-uk-gb', name: 'State Bank of India (UK)', category: BankCategory.FOREIGN, country: 'GB', charges: [] },
  'triodos-bank-uk-gb': { id: 'triodos-gb', slug: 'triodos-bank-uk-gb', name: 'Triodos Bank UK', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'atom-bank-gb': { id: 'atom-gb', slug: 'atom-bank-gb', name: 'Atom Bank (Digital)', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'monzo-bank-gb': { id: 'monzo-gb', slug: 'monzo-bank-gb', name: 'Monzo Bank (Digital)', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'starling-bank-gb': { id: 'starling-gb', slug: 'starling-bank-gb', name: 'Starling Bank (Digital)', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'revolut-bank-gb': { id: 'revolut-gb', slug: 'revolut-bank-gb', name: 'Revolut Bank (Digital)', category: BankCategory.PAYMENT_SERVICE, country: 'GB', charges: [] },
  'tide-bank-gb': { id: 'tide-gb', slug: 'tide-bank-gb', name: 'Tide Bank (Business Neobank)', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'cashplus-bank-gb': { id: 'cashplus-gb', slug: 'cashplus-bank-gb', name: 'Cashplus Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'monese-gb': { id: 'monese-gb', slug: 'monese-gb', name: 'Monese', category: BankCategory.PAYMENT_SERVICE, country: 'GB', charges: [] },
  'wise-bank-gb': { id: 'wise-gb', slug: 'wise-bank-gb', name: 'Wise', category: BankCategory.PAYMENT_SERVICE, country: 'GB', charges: [] },
  'oaknorth-bank-gb': { id: 'oaknorth-gb', slug: 'oaknorth-bank-gb', name: 'OakNorth Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'zopa-bank-gb': { id: 'zopa-gb', slug: 'zopa-bank-gb', name: 'Zopa Bank', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  'first-direct-gb': { id: 'first-direct-gb', slug: 'first-direct-gb', name: 'First Direct', category: BankCategory.PRIVATE, country: 'GB', charges: [] },
  
  // == Canada Banks ==
  'rbc-ca': {
    id: 'rbc-ca',
    slug: 'rbc-ca',
    name: 'RBC',
    category: BankCategory.PRIVATE,
    country: 'CA',
    charges: [],
  },
  'td-ca': {
    id: 'td-ca',
    slug: 'td-ca',
    name: 'TD Canada Trust',
    category: BankCategory.PRIVATE,
    country: 'CA',
    charges: [],
  },
  'scotiabank-ca': {
    id: 'scotiabank-ca',
    slug: 'scotiabank-ca',
    name: 'Scotiabank',
    category: BankCategory.PRIVATE,
    country: 'CA',
    charges: [],
  },
  'bmo-ca': {
    id: 'bmo-ca',
    slug: 'bmo-ca',
    name: 'BMO',
    category: BankCategory.PRIVATE,
    country: 'CA',
    charges: [],
  },
  'cibc-ca': {
    id: 'cibc-ca',
    slug: 'cibc-ca',
    name: 'CIBC',
    category: BankCategory.PRIVATE,
    country: 'CA',
    charges: [],
  },
  'national-bank-of-canada-ca': {
      id: 'nbc-ca',
      slug: 'national-bank-of-canada-ca',
      name: 'National Bank of Canada',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'laurentian-bank-ca': {
      id: 'laurentian-ca',
      slug: 'laurentian-bank-ca',
      name: 'Laurentian Bank of Canada',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'canadian-western-bank-ca': {
      id: 'cwb-ca',
      slug: 'canadian-western-bank-ca',
      name: 'Canadian Western Bank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'eq-bank-ca': {
      id: 'eq-bank-ca',
      slug: 'eq-bank-ca',
      name: 'EQ Bank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'manulife-bank-ca': {
      id: 'manulife-ca',
      slug: 'manulife-bank-ca',
      name: 'Manulife Bank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'tangerine-bank-ca': {
      id: 'tangerine-ca',
      slug: 'tangerine-bank-ca',
      name: 'Tangerine Bank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'simplii-financial-ca': {
      id: 'simplii-ca',
      slug: 'simplii-financial-ca',
      name: 'Simplii Financial',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'pc-financial-ca': {
      id: 'pc-financial-ca',
      slug: 'pc-financial-ca',
      name: 'President\'s Choice Financial',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'canadian-tire-bank-ca': {
      id: 'ct-bank-ca',
      slug: 'canadian-tire-bank-ca',
      name: 'Canadian Tire Bank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'wealthsimple-ca': {
      id: 'wealthsimple-ca',
      slug: 'wealthsimple-ca',
      name: 'Wealthsimple',
      category: BankCategory.PAYMENT_SERVICE,
      country: 'CA',
      charges: [],
  },
  'neo-financial-ca': {
      id: 'neo-financial-ca',
      slug: 'neo-financial-ca',
      name: 'Neo Financial',
      category: BankCategory.PAYMENT_SERVICE,
      country: 'CA',
      charges: [],
  },
  'motusbank-ca': {
      id: 'motusbank-ca',
      slug: 'motusbank-ca',
      name: 'Motusbank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'alterna-bank-ca': {
      id: 'alterna-bank-ca',
      slug: 'alterna-bank-ca',
      name: 'Alterna Bank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'hsbc-bank-canada-ca': {
      id: 'hsbc-ca',
      slug: 'hsbc-bank-canada-ca',
      name: 'HSBC Bank Canada',
      category: BankCategory.FOREIGN,
      country: 'CA',
      charges: [],
  },
  'icici-bank-canada-ca': {
      id: 'icici-ca',
      slug: 'icici-bank-canada-ca',
      name: 'ICICI Bank Canada',
      category: BankCategory.FOREIGN,
      country: 'CA',
      charges: [],
  },
  'sbi-canada-bank-ca': {
      id: 'sbi-ca',
      slug: 'sbi-canada-bank-ca',
      name: 'State Bank of India (Canada)',
      category: BankCategory.FOREIGN,
      country: 'CA',
      charges: [],
  },
  'bank-of-china-canada-ca': {
      id: 'boc-ca',
      slug: 'bank-of-china-canada-ca',
      name: 'Bank of China (Canada)',
      category: BankCategory.FOREIGN,
      country: 'CA',
      charges: [],
  },
  'citibank-canada-ca': {
      id: 'citi-ca',
      slug: 'citibank-canada-ca',
      name: 'Citibank Canada',
      category: BankCategory.FOREIGN,
      country: 'CA',
      charges: [],
  },
  'amex-bank-of-canada-ca': {
      id: 'amex-bank-ca',
      slug: 'amex-bank-of-canada-ca',
      name: 'Amex Bank of Canada',
      category: BankCategory.FOREIGN,
      country: 'CA',
      charges: [],
  },
  'vancity-ca': {
      id: 'vancity-ca',
      slug: 'vancity-ca',
      name: 'Vancity',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'coast-capital-savings-ca': {
      id: 'coast-capital-ca',
      slug: 'coast-capital-savings-ca',
      name: 'Coast Capital Savings',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'first-west-credit-union-ca': {
      id: 'first-west-ca',
      slug: 'first-west-credit-union-ca',
      name: 'First West Credit Union',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'servus-credit-union-ca': {
      id: 'servus-ca',
      slug: 'servus-credit-union-ca',
      name: 'Servus Credit Union',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'connectfirst-credit-union-ca': {
      id: 'connectfirst-ca',
      slug: 'connectfirst-credit-union-ca',
      name: 'ConnectFirst Credit Union',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'conexus-credit-union-ca': {
      id: 'conexus-ca',
      slug: 'conexus-credit-union-ca',
      name: 'Conexus Credit Union',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'affinity-credit-union-ca': {
      id: 'affinity-ca',
      slug: 'affinity-credit-union-ca',
      name: 'Affinity Credit Union',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'steinbach-credit-union-ca': {
      id: 'scu-ca',
      slug: 'steinbach-credit-union-ca',
      name: 'Steinbach Credit Union',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'access-credit-union-ca': {
      id: 'access-cu-ca',
      slug: 'access-credit-union-ca',
      name: 'Access Credit Union',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'meridian-credit-union-ca': {
      id: 'meridian-cu-ca',
      slug: 'meridian-credit-union-ca',
      name: 'Meridian Credit Union',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'desjardins-group-ca': {
      id: 'desjardins-ca',
      slug: 'desjardins-group-ca',
      name: 'Desjardins Group',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'east-coast-credit-union-ca': {
      id: 'east-coast-cu-ca',
      slug: 'east-coast-credit-union-ca',
      name: 'East Coast Credit Union',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'atb-financial-ca': {
      id: 'atb-ca',
      slug: 'atb-financial-ca',
      name: 'ATB Financial',
      category: BankCategory.PUBLIC,
      country: 'CA',
      charges: [],
  },
  'first-nations-bank-ca': {
      id: 'fnbc-ca',
      slug: 'first-nations-bank-ca',
      name: 'First Nations Bank of Canada',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'bridgewater-bank-ca': {
      id: 'bridgewater-ca',
      slug: 'bridgewater-bank-ca',
      name: 'Bridgewater Bank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'homeequity-bank-ca': {
      id: 'homeequity-ca',
      slug: 'homeequity-bank-ca',
      name: 'HomeEquity Bank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },
  'home-bank-ca': {
      id: 'home-bank-ca',
      slug: 'home-bank-ca',
      name: 'Home Bank',
      category: BankCategory.PRIVATE,
      country: 'CA',
      charges: [],
  },

  // == Australia Banks ==
  'commbank-au': {
    id: 'commbank-au',
    slug: 'commbank-au',
    name: 'Commonwealth Bank',
    category: BankCategory.PRIVATE,
    country: 'AU',
    charges: [],
  },
  'westpac-au': {
    id: 'westpac-au',
    slug: 'westpac-au',
    name: 'Westpac',
    category: BankCategory.PRIVATE,
    country: 'AU',
    charges: [],
  },
  'nab-au': {
    id: 'nab-au',
    slug: 'nab-au',
    name: 'NAB',
    category: BankCategory.PRIVATE,
    country: 'AU',
    charges: [],
  },
  'anz-au': {
    id: 'anz-au',
    slug: 'anz-au',
    name: 'ANZ',
    category: BankCategory.PRIVATE,
    country: 'AU',
    charges: [],
  },
  'macquarie-bank-au': {
    id: 'macquarie-au',
    slug: 'macquarie-bank-au',
    name: 'Macquarie Bank',
    category: BankCategory.PRIVATE,
    country: 'AU',
    charges: [],
  },
  'st-george-bank-au': { id: 'st-george-au', slug: 'st-george-bank-au', name: 'St. George Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'bank-of-melbourne-au': { id: 'bom-au', slug: 'bank-of-melbourne-au', name: 'Bank of Melbourne', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'banksa-au': { id: 'banksa-au', slug: 'banksa-au', name: 'BankSA', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'suncorp-bank-au': { id: 'suncorp-au', slug: 'suncorp-bank-au', name: 'Suncorp Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'bank-of-queensland-au': { id: 'boq-au', slug: 'bank-of-queensland-au', name: 'Bank of Queensland (BOQ)', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'bendigo-bank-au': { id: 'bendigo-au', slug: 'bendigo-bank-au', name: 'Bendigo and Adelaide Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'amp-bank-au': { id: 'amp-au', slug: 'amp-bank-au', name: 'AMP Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'me-bank-au': { id: 'me-bank-au', slug: 'me-bank-au', name: 'ME Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'ing-australia-au': { id: 'ing-au', slug: 'ing-australia-au', name: 'ING Australia', category: BankCategory.FOREIGN, country: 'AU', charges: [] },
  'hsbc-australia-au': { id: 'hsbc-au', slug: 'hsbc-australia-au', name: 'HSBC Bank Australia', category: BankCategory.FOREIGN, country: 'AU', charges: [] },
  'citibank-australia-au': { id: 'citi-au', slug: 'citibank-australia-au', name: 'Citibank Australia', category: BankCategory.FOREIGN, country: 'AU', charges: [] },
  'ubank-au': { id: 'ubank-au', slug: 'ubank-au', name: 'UBank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'up-bank-au': { id: 'up-bank-au', slug: 'up-bank-au', name: 'Up Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'great-southern-bank-au': { id: 'gsb-au', slug: 'great-southern-bank-au', name: 'Great Southern Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'heritage-bank-au': { id: 'heritage-au', slug: 'heritage-bank-au', name: 'Heritage Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'peoples-choice-cu-au': { id: 'peoples-choice-au', slug: 'peoples-choice-cu-au', name: 'People\'s Choice Credit Union', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'beyond-bank-au': { id: 'beyond-bank-au', slug: 'beyond-bank-au', name: 'Beyond Bank Australia', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'newcastle-permanent-au': { id: 'newcastle-permanent-au', slug: 'newcastle-permanent-au', name: 'Newcastle Permanent', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'teachers-mutual-bank-au': { id: 'tmb-au', slug: 'teachers-mutual-bank-au', name: 'Teachers Mutual Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'bank-australia-au': { id: 'bank-australia-au', slug: 'bank-australia-au', name: 'Bank Australia', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'pn-bank-au': { id: 'pn-bank-au', slug: 'pn-bank-au', name: 'P&N Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'imb-bank-au': { id: 'imb-au', slug: 'imb-bank-au', name: 'IMB Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'greater-bank-au': { id: 'greater-bank-au', slug: 'greater-bank-au', name: 'Greater Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'police-bank-au': { id: 'police-bank-au', slug: 'police-bank-au', name: 'Police Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'qudos-bank-au': { id: 'qudos-au', slug: 'qudos-bank-au', name: 'Qudos Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'bank-of-us-au': { id: 'bankofus-au', slug: 'bank-of-us-au', name: 'Bank of us', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'racq-bank-au': { id: 'racq-au', slug: 'racq-bank-au', name: 'RACQ Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'auswide-bank-au': { id: 'auswide-au', slug: 'auswide-bank-au', name: 'Auswide Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'bankwest-au': { id: 'bankwest-au', slug: 'bankwest-au', name: 'Bankwest', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'defence-bank-au': { id: 'defence-bank-au', slug: 'defence-bank-au', name: 'Defence Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'mystate-bank-au': { id: 'mystate-au', slug: 'mystate-bank-au', name: 'MyState Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'gc-mutual-bank-au': { id: 'gc-mutual-au', slug: 'gc-mutual-bank-au', name: 'G&C Mutual Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'australian-unity-bank-au': { id: 'australian-unity-au', slug: 'australian-unity-bank-au', name: 'Australian Unity Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'gateway-bank-au': { id: 'gateway-au', slug: 'gateway-bank-au', name: 'Gateway Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'regional-australia-bank-au': { id: 'regional-aus-au', slug: 'regional-australia-bank-au', name: 'Regional Australia Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'bank-first-au': { id: 'bank-first-au', slug: 'bank-first-au', name: 'Bank First', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'the-mutual-bank-au': { id: 'the-mutual-au', slug: 'the-mutual-bank-au', name: 'The Mutual Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'hume-bank-au': { id: 'hume-au', slug: 'hume-bank-au', name: 'Hume Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'unity-bank-au': { id: 'unity-au', slug: 'unity-bank-au', name: 'Unity Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'firefighters-mutual-bank-au': { id: 'firefighters-mutual-au', slug: 'firefighters-mutual-bank-au', name: 'Firefighters Mutual Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'health-professionals-bank-au': { id: 'health-pro-au', slug: 'health-professionals-bank-au', name: 'Health Professionals Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'unibank-au': { id: 'unibank-au', slug: 'unibank-au', name: 'UniBank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'community-first-cu-au': { id: 'community-first-au', slug: 'community-first-cu-au', name: 'Community First Credit Union', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'endeavour-mutual-bank-au': { id: 'endeavour-mutual-au', slug: 'endeavour-mutual-bank-au', name: 'Endeavour Mutual Bank', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'bank-of-sydney-au': { id: 'bank-of-sydney-au', slug: 'bank-of-sydney-au', name: 'Bank of Sydney', category: BankCategory.PRIVATE, country: 'AU', charges: [] },
  'credit-union-sa-au': { id: 'credit-union-sa-au', slug: 'credit-union-sa-au', name: 'Credit Union SA', category: BankCategory.PRIVATE, country: 'AU', charges: [] },

  // == Singapore Banks ==
  'dbs-sg': { id: 'dbs-sg', slug: 'dbs-sg', name: 'DBS Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'ocbc-sg': { id: 'ocbc-sg', slug: 'ocbc-sg', name: 'OCBC Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'uob-sg': { id: 'uob-sg', slug: 'uob-sg', name: 'UOB', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'standard-chartered-sg': { id: 'sc-sg', slug: 'standard-chartered-sg', name: 'Standard Chartered Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'citibank-sg': { id: 'citi-sg', slug: 'citibank-sg', name: 'Citibank Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'hsbc-sg': { id: 'hsbc-sg', slug: 'hsbc-sg', name: 'HSBC Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'maybank-sg': { id: 'maybank-sg', slug: 'maybank-sg', name: 'Maybank Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'cimb-sg': { id: 'cimb-sg', slug: 'cimb-sg', name: 'CIMB Bank Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'rhb-sg': { id: 'rhb-sg', slug: 'rhb-sg', name: 'RHB Bank Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'bank-of-china-sg': { id: 'boc-sg', slug: 'bank-of-china-sg', name: 'Bank of China Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'icbc-sg': { id: 'icbc-sg', slug: 'icbc-sg', name: 'ICBC Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'trust-bank-sg': { id: 'trust-sg', slug: 'trust-bank-sg', name: 'Trust Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'gxs-bank-sg': { id: 'gxs-sg', slug: 'gxs-bank-sg', name: 'GXS Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'bank-of-india-sg': { id: 'boi-sg', slug: 'bank-of-india-sg', name: 'Bank of India Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'indian-overseas-bank-sg': { id: 'iob-sg', slug: 'indian-overseas-bank-sg', name: 'Indian Overseas Bank Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'sbi-sg': { id: 'sbi-sg', slug: 'sbi-sg', name: 'State Bank of India Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'bnp-paribas-sg': { id: 'bnp-sg', slug: 'bnp-paribas-sg', name: 'BNP Paribas Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'deutsche-bank-sg': { id: 'deutsche-sg', slug: 'deutsche-bank-sg', name: 'Deutsche Bank Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'jp-morgan-chase-sg': { id: 'jpm-sg', slug: 'jp-morgan-chase-sg', name: 'J.P. Morgan Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'mizuho-bank-sg': { id: 'mizuho-sg', slug: 'mizuho-bank-sg', name: 'Mizuho Bank Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'sumitomo-mitsui-sg': { id: 'smbc-sg', slug: 'sumitomo-mitsui-sg', name: 'SMBC Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'ubs-sg': { id: 'ubs-sg', slug: 'ubs-sg', name: 'UBS Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'credit-suisse-sg': { id: 'cs-sg', slug: 'credit-suisse-sg', name: 'Credit Suisse Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'barclays-sg': { id: 'barclays-sg', slug: 'barclays-sg', name: 'Barclays Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'anz-sg': { id: 'anz-sg', slug: 'anz-sg', name: 'ANZ Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'macquarie-sg': { id: 'macquarie-sg', slug: 'macquarie-sg', name: 'Macquarie Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'nomura-sg': { id: 'nomura-sg', slug: 'nomura-sg', name: 'Nomura Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'goldman-sachs-sg': { id: 'gs-sg', slug: 'goldman-sachs-sg', name: 'Goldman Sachs Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'morgan-stanley-sg': { id: 'ms-sg', slug: 'morgan-stanley-sg', name: 'Morgan Stanley Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'lgt-bank-sg': { id: 'lgt-sg', slug: 'lgt-bank-sg', name: 'LGT Bank Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'julius-baer-sg': { id: 'jb-sg', slug: 'julius-baer-sg', name: 'Julius Baer Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'pictet-sg': { id: 'pictet-sg', slug: 'pictet-sg', name: 'Pictet Singapore', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'keppel-bank-sg': { id: 'keppel-sg', slug: 'keppel-bank-sg', name: 'Keppel Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'sentosa-savings-sg': { id: 'sentosa-sg', slug: 'sentosa-savings-sg', name: 'Sentosa Savings & Loan', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'marina-bay-bank-sg': { id: 'mbb-sg', slug: 'marina-bay-bank-sg', name: 'Marina Bay Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'temasek-credit-sg': { id: 'temasek-sg', slug: 'temasek-credit-sg', name: 'Temasek Credit', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'merlion-finance-sg': { id: 'merlion-sg', slug: 'merlion-finance-sg', name: 'Merlion Finance', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'orchard-road-bank-sg': { id: 'orchard-sg', slug: 'orchard-road-bank-sg', name: 'Orchard Road Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'straits-private-bank-sg': { id: 'straits-sg', slug: 'straits-private-bank-sg', name: 'Straits Private Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'asia-wealth-management-sg': { id: 'awm-sg', slug: 'asia-wealth-management-sg', name: 'Asia Wealth Management', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'lion-city-capital-sg': { id: 'lcc-sg', slug: 'lion-city-capital-sg', name: 'Lion City Capital', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'raffles-investment-bank-sg': { id: 'rib-sg', slug: 'raffles-investment-bank-sg', name: 'Raffles Investment Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'singapura-digital-bank-sg': { id: 'sdb-sg', slug: 'singapura-digital-bank-sg', name: 'Singapura Digital Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'pacific-rim-bank-sg': { id: 'prb-sg', slug: 'pacific-rim-bank-sg', name: 'Pacific Rim Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'southeast-asia-bank-sg': { id: 'seab-sg', slug: 'southeast-asia-bank-sg', name: 'Southeast Asia Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'equatorial-bank-sg': { id: 'eqb-sg', slug: 'equatorial-bank-sg', name: 'Equatorial Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'harbourfront-finance-sg': { id: 'hff-sg', slug: 'harbourfront-finance-sg', name: 'HarbourFront Finance', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'bukit-timah-savings-sg': { id: 'bts-sg', slug: 'bukit-timah-savings-sg', name: 'Bukit Timah Savings', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'esplanade-credit-union-sg': { id: 'ecu-sg', slug: 'esplanade-credit-union-sg', name: 'Esplanade Credit Union', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'katong-community-bank-sg': { id: 'kcb-sg', slug: 'katong-community-bank-sg', name: 'Katong Community Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'nanyang-financial-sg': { id: 'nyf-sg', slug: 'nanyang-financial-sg', name: 'Nanyang Financial', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'clarke-quay-capital-sg': { id: 'cqc-sg', slug: 'clarke-quay-capital-sg', name: 'Clarke Quay Capital', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'tanjong-pagar-bank-sg': { id: 'tpb-sg', slug: 'tanjong-pagar-bank-sg', name: 'Tanjong Pagar Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'changi-international-bank-sg': { id: 'cib-sg', slug: 'changi-international-bank-sg', name: 'Changi International Bank', category: BankCategory.FOREIGN, country: 'SG', charges: [] },
  'tekong-investment-group-sg': { id: 'tig-sg', slug: 'tekong-investment-group-sg', name: 'Tekong Investment Group', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'ubin-wealth-sg': { id: 'ubin-sg', slug: 'ubin-wealth-sg', name: 'Ubin Wealth', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'holland-village-bank-sg': { id: 'hvb-sg', slug: 'holland-village-bank-sg', name: 'Holland Village Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'serangoon-financial-sg': { id: 'sfs-sg', slug: 'serangoon-financial-sg', name: 'Serangoon Financial Services', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'geylang-mutual-sg': { id: 'gms-sg', slug: 'geylang-mutual-sg', name: 'Geylang Mutual Savings', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'jurong-industrial-bank-sg': { id: 'jib-sg', slug: 'jurong-industrial-bank-sg', name: 'Jurong Industrial Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'suntec-city-bank-sg': { id: 'scb-sg', slug: 'suntec-city-bank-sg', name: 'Suntec City Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'yishun-central-bank-sg': { id: 'ycb-sg', slug: 'yishun-central-bank-sg', name: 'Yishun Central Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'woodlands-regional-bank-sg': { id: 'wrb-sg', slug: 'woodlands-regional-bank-sg', name: 'Woodlands Regional Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'pasir-ris-credit-sg': { id: 'prc-sg', slug: 'pasir-ris-credit-sg', name: 'Pasir Ris Credit', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'bedok-reservoir-bank-sg': { id: 'brb-sg', slug: 'bedok-reservoir-bank-sg', name: 'Bedok Reservoir Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'clementi-capital-sg': { id: 'cc-sg', slug: 'clementi-capital-sg', name: 'Clementi Capital', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'ang-mo-kio-bank-sg': { id: 'amk-sg', slug: 'ang-mo-kio-bank-sg', name: 'Ang Mo Kio Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'toa-payoh-central-bank-sg': { id: 'tpcb-sg', slug: 'toa-payoh-central-bank-sg', name: 'Toa Payoh Central Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'bishan-financial-corp-sg': { id: 'bfc-sg', slug: 'bishan-financial-corp-sg', name: 'Bishan Financial Corp', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'dempsey-hill-private-bank-sg': { id: 'dhpb-sg', slug: 'dempsey-hill-private-bank-sg', name: 'Dempsey Hill Private Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'east-coast-bankers-sg': { id: 'ecb-sg', slug: 'east-coast-bankers-sg', name: 'East Coast Bankers', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'novena-wealth-managers-sg': { id: 'nwm-sg', slug: 'novena-wealth-managers-sg', name: 'Novena Wealth Managers', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'somerset-investment-bank-sg': { id: 'sib-sg', slug: 'somerset-investment-bank-sg', name: 'Somerset Investment Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'city-hall-financial-sg': { id: 'chf-sg', slug: 'city-hall-financial-sg', name: 'City Hall Financial', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'dhoby-ghaut-bank-sg': { id: 'dgb-sg', slug: 'dhoby-ghaut-bank-sg', name: 'Dhoby Ghaut Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'bugis-junction-bank-sg': { id: 'bjb-sg', slug: 'bugis-junction-bank-sg', name: 'Bugis Junction Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'lavender-street-capital-sg': { id: 'lsc-sg', slug: 'lavender-street-capital-sg', name: 'Lavender Street Capital', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'farrer-park-finance-sg': { id: 'fpf-sg', slug: 'farrer-park-finance-sg', name: 'Farrer Park Finance', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'orchard-boulevard-bank-sg': { id: 'obb-sg', slug: 'orchard-boulevard-bank-sg', name: 'Orchard Boulevard Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'river-valley-credit-sg': { id: 'rvc-sg', slug: 'river-valley-credit-sg', name: 'River Valley Credit', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'tiong-bahru-heritage-bank-sg': { id: 'tbhb-sg', slug: 'tiong-bahru-heritage-bank-sg', name: 'Tiong Bahru Heritage Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'redhill-capital-sg': { id: 'rhc-sg', slug: 'redhill-capital-sg', name: 'Redhill Capital', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'queenstown-savings-bank-sg': { id: 'qsb-sg', slug: 'queenstown-savings-bank-sg', name: 'Queenstown Savings Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'commonwealth-avenue-bank-sg': { id: 'cab-sg', slug: 'commonwealth-avenue-bank-sg', name: 'Commonwealth Avenue Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'buona-vista-investments-sg': { id: 'bvi-sg', slug: 'buona-vista-investments-sg', name: 'Buona Vista Investments', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'one-north-digital-bank-sg': { id: 'ondb-sg', slug: 'one-north-digital-bank-sg', name: 'One-North Digital Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'dover-road-financial-sg': { id: 'drf-sg', slug: 'dover-road-financial-sg', name: 'Dover Road Financial', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'botanic-gardens-bank-sg': { id: 'bgb-sg', slug: 'botanic-gardens-bank-sg', name: 'Botanic Gardens Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'newton-circus-bank-sg': { id: 'ncb-sg', slug: 'newton-circus-bank-sg', name: 'Newton Circus Bank', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
  'thomson-road-capital-sg': { id: 'trc-sg', slug: 'thomson-road-capital-sg', name: 'Thomson Road Capital', category: BankCategory.PRIVATE, country: 'SG', charges: [] },
};

export const upiApps: Record<string, UpiAppDetail> = {
  // Third-Party (India)
  'google-pay-in': { id: 'gpay', slug: 'google-pay-in', name: 'Google Pay', country: 'IN', charges: [], foundingYear: '2017 (as Tez)', primaryFeatures: ['UPI Payments & Transfers', 'Bill Payments & Recharges', 'NFC-based Tap & Pay', 'Business Tools'] },
  'phonepe-in': { id: 'phonepe', slug: 'phonepe-in', name: 'PhonePe', country: 'IN', charges: [], foundingYear: '2015', primaryFeatures: ['UPI Payments', 'Digital Wallet', 'Bill Payments', 'Financial Services (Insurance, Mutual Funds)'] },
  'paytm-in': { id: 'paytm', slug: 'paytm-in', name: 'Paytm', country: 'IN', charges: [] },
  'amazon-pay-in': { id: 'amazonpay', slug: 'amazon-pay-in', name: 'Amazon Pay UPI', country: 'IN', charges: [] },
  'whatsapp-pay-in': { id: 'whatsapppay', slug: 'whatsapp-pay-in', name: 'WhatsApp Pay', country: 'IN', charges: [] },
  'cred-upi-in': { id: 'cred', slug: 'cred-upi-in', name: 'CRED UPI', country: 'IN', charges: [] },
  'mobikwik-in': { id: 'mobikwik', slug: 'mobikwik-in', name: 'MobiKwik UPI', country: 'IN', charges: [] },
  'freecharge-in': { id: 'freecharge', slug: 'freecharge-in', name: 'Freecharge UPI', country: 'IN', charges: [] },
  'slice-in': { id: 'slice', slug: 'slice-in', name: 'Slice UPI', country: 'IN', charges: [] },
  'tata-neu-upi-in': { id: 'tata-neu', slug: 'tata-neu-upi-in', name: 'Tata Neu UPI', country: 'IN', charges: [] },
  'truecaller-pay-in': { id: 'truecaller', slug: 'truecaller-pay-in', name: 'Truecaller Pay', country: 'IN', charges: [] },
  'jupiter-upi-in': { id: 'jupiter', slug: 'jupiter-upi-in', name: 'Jupiter UPI', country: 'IN', charges: [] },
  'fi-money-upi-in': { id: 'fi-money', slug: 'fi-money-upi-in', name: 'Fi Money UPI', country: 'IN', charges: [] },
  'navi-upi-in': { id: 'navi', slug: 'navi-upi-in', name: 'Navi UPI', country: 'IN', charges: [] },
  'jio-pay-in': { id: 'jiopay', slug: 'jio-pay-in', name: 'JioPay', country: 'IN', charges: [] },

  // Bank-owned (India)
  'bhim-in': { id: 'bhim', slug: 'bhim-in', name: 'BHIM', country: 'IN', charges: [] },
  'sbi-yono-in': { id: 'sbi-yono', slug: 'sbi-yono-in', name: 'SBI YONO', country: 'IN', charges: [] },
  'hdfc-payzapp-in': { id: 'hdfc-payzapp', slug: 'hdfc-payzapp-in', name: 'HDFC PayZapp', country: 'IN', charges: [] },
  'icici-imobile-pay-in': { id: 'icici-imobile', slug: 'icici-imobile-pay-in', name: 'ICICI iMobile Pay', country: 'IN', charges: [] },
  'axis-mobile-upi-in': { id: 'axis-mobile', slug: 'axis-mobile-upi-in', name: 'Axis Bank UPI App', country: 'IN', charges: [] },
  'kotak-mobile-upi-in': { id: 'kotak-mobile', slug: 'kotak-mobile-upi-in', name: 'Kotak Mobile Banking App', country: 'IN', charges: [] },
  'pnb-one-in': { id: 'pnb-one', slug: 'pnb-one-in', name: 'PNB ONE', country: 'IN', charges: [] },
  'bob-world-in': { id: 'bob-world', slug: 'bob-world-in', name: 'Bank of Baroda M-Connect+', country: 'IN', charges: [] },
  'canara-ai1-in': { id: 'canara-ai1', slug: 'canara-ai1-in', name: 'Canara ai1', country: 'IN', charges: [] },
  'federal-fedmobile-in': { id: 'fedmobile', slug: 'federal-fedmobile-in', name: 'FedMobile', country: 'IN', charges: [] },

  // == US Payment Apps ==
  'paypal-us': { id: 'paypal-us', slug: 'paypal-us', name: 'PayPal', country: 'US', charges: [] },
  'venmo-us': { id: 'venmo-us', slug: 'venmo-us', name: 'Venmo', country: 'US', charges: [] },
  'cash-app-us': { id: 'cash-app-us', slug: 'cash-app-us', name: 'Cash App', country: 'US', charges: [] },
  'zelle-us': { id: 'zelle-us', slug: 'zelle-us', name: 'Zelle', country: 'US', charges: [] },
  'apple-pay-us': { id: 'apple-pay-us', slug: 'apple-pay-us', name: 'Apple Pay', country: 'US', charges: [] },
  'google-pay-us': { id: 'google-pay-us', slug: 'google-pay-us', name: 'Google Pay', country: 'US', charges: [] },
  'samsung-pay-us': { id: 'samsung-pay-us', slug: 'samsung-pay-us', name: 'Samsung Pay', country: 'US', charges: [] },
  'stripe-us': { id: 'stripe-us', slug: 'stripe-us', name: 'Stripe', country: 'US', charges: [] },
  'square-us': { id: 'square-us', slug: 'square-us', name: 'Square', country: 'US', charges: [] },
  'coinbase-wallet-us': { id: 'coinbase-wallet-us', slug: 'coinbase-wallet-us', name: 'Coinbase Wallet', country: 'US', charges: [] },
  'meta-pay-us': { id: 'meta-pay-us', slug: 'meta-pay-us', name: 'Meta Pay', country: 'US', charges: [] },
  'wise-us': { id: 'wise-us', slug: 'wise-us', name: 'Wise (US)', country: 'US', charges: [] },
  'remitly-us': { id: 'remitly-us', slug: 'remitly-us', name: 'Remitly', country: 'US', charges: [] },
  'skrill-us': { id: 'skrill-us', slug: 'skrill-us', name: 'Skrill', country: 'US', charges: [] },
  'paysend-us': { id: 'paysend-us', slug: 'paysend-us', name: 'Paysend', country: 'US', charges: [] },

  // == UK Payment Apps ==
  'paypal-gb': { id: 'paypal-gb', slug: 'paypal-gb', name: 'PayPal (UK)', country: 'GB', charges: [] },
  'google-pay-gb': { id: 'google-pay-gb', slug: 'google-pay-gb', name: 'Google Pay', country: 'GB', charges: [] },
  'apple-pay-gb': { id: 'apple-pay-gb', slug: 'apple-pay-gb', name: 'Apple Pay', country: 'GB', charges: [] },
  'samsung-pay-gb': { id: 'samsung-pay-gb', slug: 'samsung-pay-gb', name: 'Samsung Pay', country: 'GB', charges: [] },
  'revolut-app-gb': { id: 'revolut-app-gb', slug: 'revolut-app-gb', name: 'Revolut App', country: 'GB', charges: [] },
  'monzo-app-gb': { id: 'monzo-app-gb', slug: 'monzo-app-gb', name: 'Monzo App', country: 'GB', charges: [] },
  'starling-app-gb': { id: 'starling-app-gb', slug: 'starling-app-gb', name: 'Starling App', country: 'GB', charges: [] },
  'wise-app-gb': { id: 'wise-app-gb', slug: 'wise-app-gb', name: 'Wise App', country: 'GB', charges: [] },
  'cash-app-gb': { id: 'cash-app-gb', slug: 'cash-app-gb', name: 'Cash App', country: 'GB', charges: [] },
  'skrill-gb': { id: 'skrill-gb', slug: 'skrill-gb', name: 'Skrill', country: 'GB', charges: [] },
  'neteller-gb': { id: 'neteller-gb', slug: 'neteller-gb', name: 'Neteller', country: 'GB', charges: [] },
  'paysend-gb': { id: 'paysend-gb', slug: 'paysend-gb', name: 'Paysend', country: 'GB', charges: [] },
  'remitly-gb': { id: 'remitly-gb', slug: 'remitly-gb', name: 'Remitly', country: 'GB', charges: [] },
  'zilch-gb': { id: 'zilch-gb', slug: 'zilch-gb', name: 'Zilch', country: 'GB', charges: [] },
  'klarna-gb': { id: 'klarna-gb', slug: 'klarna-gb', name: 'Klarna', country: 'GB', charges: [] },
  'curve-gb': { id: 'curve-gb', slug: 'curve-gb', name: 'Curve', country: 'GB', charges: [] },
  'payoneer-gb': { id: 'payoneer-gb', slug: 'payoneer-gb', name: 'Payoneer', country: 'GB', charges: [] },
  'worldremit-gb': { id: 'worldremit-gb', slug: 'worldremit-gb', name: 'WorldRemit', country: 'GB', charges: [] },
  'stripe-gb': { id: 'stripe-gb', slug: 'stripe-gb', name: 'Stripe', country: 'GB', charges: [] },
  'square-gb': { id: 'square-gb', slug: 'square-gb', name: 'Square UK', country: 'GB', charges: [] },
  'paym-gb': { id: 'paym-gb', slug: 'paym-gb', name: 'Paym', country: 'GB', charges: [] },

  // == Singapore Payment Apps ==
  'dbs-paylah-sg': { id: 'dbs-paylah-sg', slug: 'dbs-paylah-sg', name: 'DBS PayLah!', country: 'SG', charges: [], foundingYear: '2014', primaryFeatures: ['P2P Transfers via PayNow', 'Scan & Pay (NETS QR)', 'Bill Payments', 'Booking Tickets'] },
  'grabpay-sg': { id: 'grabpay-sg', slug: 'grabpay-sg', name: 'GrabPay', country: 'SG', charges: [], foundingYear: '2016', primaryFeatures: ['In-app payments for Grab services', 'In-store QR code payments', 'Points & Rewards System', 'International Remittance'] },
  'singtel-dash-sg': { id: 'singtel-dash-sg', slug: 'singtel-dash-sg', name: 'Singtel Dash', country: 'SG', charges: [], foundingYear: '2014', primaryFeatures: ['Mobile Remittance', 'Transit Payments (Bus/MRT)', 'In-store Payments', 'Bill Payments'] },
  'youtrip-sg': { id: 'youtrip-sg', slug: 'youtrip-sg', name: 'YouTrip', country: 'SG', charges: [], foundingYear: '2018', primaryFeatures: ['Multi-currency Wallet', 'Wholesale Exchange Rates', 'Fee-free overseas spending', 'Physical Mastercard'] },
  'favepay-sg': { id: 'favepay-sg', slug: 'favepay-sg', name: 'FavePay', country: 'SG', charges: [], foundingYear: '2016', primaryFeatures: ['QR Code Payments', 'Instant Merchant Cashback', 'Deals & Vouchers', 'Integration with FaveDeals'] },
  'atome-sg': { id: 'atome-sg', slug: 'atome-sg', name: 'Atome', country: 'SG', charges: [], foundingYear: '2019', primaryFeatures: ['Buy Now, Pay Later (3 installments)', 'Wide merchant network', 'Interest-free payments', 'Virtual & Physical Card'] },
  'shopeepay-sg': { id: 'shopeepay-sg', slug: 'shopeepay-sg', name: 'ShopeePay', country: 'SG', charges: [], foundingYear: '2019', primaryFeatures: ['In-app payments on Shopee', 'Offline QR Payments', 'P2P Transfers', 'Deals & Vouchers'] },
  'paynow-sg': { id: 'paynow-sg', slug: 'paynow-sg', name: 'PayNow', country: 'SG', charges: [], foundingYear: '2017', primaryFeatures: ['National P2P funds transfer', 'Instant transfers using mobile/NRIC', 'QR Code payments (SGQR)', 'Integrated into banking apps'] },
  'klarna-sg': { id: 'klarna-sg', slug: 'klarna-sg', name: 'Klarna', country: 'SG', charges: [], foundingYear: '2005', primaryFeatures: ['Buy Now, Pay Later (3 or 4 installments)', 'Pay in 30 days', 'Shopping App'] },
  'shopback-pay-sg': { id: 'shopback-pay-sg', slug: 'shopback-pay-sg', name: 'ShopBack Pay', country: 'SG', charges: [], foundingYear: '2014', primaryFeatures: ['In-store QR Payments', 'Earn Cashback', 'Link with existing credit/debit cards'] },
  'ezlink-app-sg': { id: 'ezlink-app-sg', slug: 'ezlink-app-sg', name: 'EZ-Link App', country: 'SG', charges: [], foundingYear: '2002 (Card)', primaryFeatures: ['Top-up EZ-Link cards via NFC', 'Track travel history', 'Earn Rewards Points'] },
  'netspay-sg': { id: 'netspay-sg', slug: 'netspay-sg', name: 'NETSPay', country: 'SG', charges: [], foundingYear: '2017', primaryFeatures: ['Digital NETS card', 'QR Code Payments', 'NFC Payments'] },
  'krisplus-sg': { id: 'krisplus-sg', slug: 'krisplus-sg', name: 'Kris+', country: 'SG', charges: [], foundingYear: '2020', primaryFeatures: ['Earn/Redeem KrisFlyer Miles', 'In-store QR Payments', 'Deals and Privileges'] },
  'google-pay-sg': { id: 'google-pay-sg', slug: 'google-pay-sg', name: 'Google Pay Singapore', country: 'SG', charges: [], foundingYear: '2020', primaryFeatures: ['NFC Tap & Pay', 'PayNow Transfers', 'Order food & buy movie tickets'] },
  'apple-pay-sg': { id: 'apple-pay-sg', slug: 'apple-pay-sg', name: 'Apple Pay', country: 'SG', charges: [], foundingYear: '2016', primaryFeatures: ['NFC Tap & Pay', 'In-app and web payments', 'Secure card tokenization'] },
  'wise-sg': { id: 'wise-sg', slug: 'wise-sg', name: 'Wise (Singapore)', country: 'SG', charges: [], foundingYear: '2011', primaryFeatures: ['International Money Transfers', 'Multi-currency Account', 'Debit Card for overseas spending'] },
};

// Fix: Added the missing 'creditCards' export to match imports in other files.
export const creditCards: Record<string, CreditCardDetail> = {
  // == India ==
  'hdfc-regalia-in': { id: 'hdfc-regalia-in', slug: 'hdfc-regalia-in', name: 'HDFC Bank Regalia Credit Card', country: 'IN', charges: [] },
  'sbi-simplyclick-in': { id: 'sbi-simplyclick-in', slug: 'sbi-simplyclick-in', name: 'SBI SimplyCLICK Credit Card', country: 'IN', charges: [] },
  'icici-amazon-pay-in': { id: 'icici-amazon-pay-in', slug: 'icici-amazon-pay-in', name: 'Amazon Pay ICICI Bank Credit Card', country: 'IN', charges: [] },
  'axis-ace-in': { id: 'axis-ace-in', slug: 'axis-ace-in', name: 'Axis Bank ACE Credit Card', country: 'IN', charges: [] },
  'kotak-urbane-gold-in': { id: 'kotak-urbane-gold-in', slug: 'kotak-urbane-gold-in', name: 'Kotak Urbane Gold Credit Card', country: 'IN', charges: []},
  'amex-mrcc-in': { id: 'amex-mrcc-in', slug: 'amex-mrcc-in', name: 'American Express Membership Rewards® Credit Card', country: 'IN', charges: [] },
  'flipkart-axis-in': { id: 'flipkart-axis-in', slug: 'flipkart-axis-in', name: 'Flipkart Axis Bank Credit Card', country: 'IN', charges: [] },
  'hdfc-infinia-metal-in': { id: 'hdfc-infinia-metal-in', slug: 'hdfc-infinia-metal-in', name: 'HDFC Bank Infinia Metal Credit Card', country: 'IN', charges: [] },
  'hdfc-diners-club-black-in': { id: 'hdfc-diners-club-black-in', slug: 'hdfc-diners-club-black-in', name: 'HDFC Bank Diners Club Black Credit Card', country: 'IN', charges: [] },
  'hdfc-millennia-in': { id: 'hdfc-millennia-in', slug: 'hdfc-millennia-in', name: 'HDFC Bank Millennia Credit Card', country: 'IN', charges: [] },
  'hdfc-moneyback-plus-in': { id: 'hdfc-moneyback-plus-in', slug: 'hdfc-moneyback-plus-in', name: 'HDFC Bank MoneyBack+ Credit Card', country: 'IN', charges: [] },
  'hdfc-regalia-gold-in': { id: 'hdfc-regalia-gold-in', slug: 'hdfc-regalia-gold-in', name: 'HDFC Bank Regalia Gold Credit Card', country: 'IN', charges: [] },
  'hdfc-tata-neu-infinity-in': { id: 'hdfc-tata-neu-infinity-in', slug: 'hdfc-tata-neu-infinity-in', name: 'Tata Neu Plus HDFC Bank Credit Card', country: 'IN', charges: [] },
  'hdfc-tata-neu-plus-in': { id: 'hdfc-tata-neu-plus-in', slug: 'hdfc-tata-neu-plus-in', name: 'Tata Neu Infinity HDFC Bank Credit Card', country: 'IN', charges: [] },
  'hdfc-swiggy-in': { id: 'hdfc-swiggy-in', slug: 'hdfc-swiggy-in', name: 'Swiggy HDFC Bank Credit Card', country: 'IN', charges: [] },
  'hdfc-marriott-bonvoy-in': { id: 'hdfc-marriott-bonvoy-in', slug: 'hdfc-marriott-bonvoy-in', name: 'Marriott Bonvoy HDFC Bank Credit Card', country: 'IN', charges: [] },
  'hdfc-freedom-in': { id: 'hdfc-freedom-in', slug: 'hdfc-freedom-in', name: 'HDFC Bank Freedom Credit Card', country: 'IN', charges: [] },
  'hdfc-intermiles-signature-in': { id: 'hdfc-intermiles-signature-in', slug: 'hdfc-intermiles-signature-in', name: 'InterMiles HDFC Bank Signature Credit Card', country: 'IN', charges: [] },
  'hdfc-business-regalia-in': { id: 'hdfc-business-regalia-in', slug: 'hdfc-business-regalia-in', name: 'HDFC Bank Business Regalia Credit Card', country: 'IN', charges: [] },
  'hdfc-diners-privilege-in': { id: 'hdfc-diners-privilege-in', slug: 'hdfc-diners-privilege-in', name: 'HDFC Bank Diners Club Privilege Credit Card', country: 'IN', charges: [] },
  'hdfc-indian-oil-in': { id: 'hdfc-indian-oil-in', slug: 'hdfc-indian-oil-in', name: 'IndianOil HDFC Bank Credit Card', country: 'IN', charges: [] },
  'hdfc-diners-club-miles-in': { id: 'hdfc-diners-club-miles-in', slug: 'hdfc-diners-club-miles-in', name: 'HDFC Bank Diners Club Miles Credit Card', country: 'IN', charges: [] },
  'sbi-card-elite-in': { id: 'sbi-card-elite-in', slug: 'sbi-card-elite-in', name: 'SBI Card ELITE', country: 'IN', charges: [] },
  'sbi-card-prime-in': { id: 'sbi-card-prime-in', slug: 'sbi-card-prime-in', name: 'SBI Card PRIME', country: 'IN', charges: [] },
  'sbi-cashback-in': { id: 'sbi-cashback-in', slug: 'sbi-cashback-in', name: 'Cashback SBI Card', country: 'IN', charges: [] },
  'sbi-simplysave-in': { id: 'sbi-simplysave-in', slug: 'sbi-simplysave-in', name: 'SBI SimplySAVE Credit Card', country: 'IN', charges: [] },
  'sbi-bpcl-octane-in': { id: 'sbi-bpcl-octane-in', slug: 'sbi-bpcl-octane-in', name: 'BPCL SBI Card OCTANE', country: 'IN', charges: [] },
  'sbi-irctc-premier-in': { id: 'sbi-irctc-premier-in', slug: 'sbi-irctc-premier-in', name: 'IRCTC SBI Card Premier', country: 'IN', charges: [] },
  'sbi-vistara-prime-in': { id: 'sbi-vistara-prime-in', slug: 'sbi-vistara-prime-in', name: 'Club Vistara SBI Card PRIME', country: 'IN', charges: [] },
  'sbi-aurum-in': { id: 'sbi-aurum-in', slug: 'sbi-aurum-in', name: 'AURUM Card from SBI', country: 'IN', charges: [] },
  'sbi-pulse-in': { id: 'sbi-pulse-in', slug: 'sbi-pulse-in', name: 'SBI Pulse Credit Card', country: 'IN', charges: [] },
  'sbi-ola-money-in': { id: 'sbi-ola-money-in', slug: 'sbi-ola-money-in', name: 'OLA Money SBI Card', country: 'IN', charges: [] },
  'sbi-delhi-metro-in': { id: 'sbi-delhi-metro-in', slug: 'sbi-delhi-metro-in', name: 'Delhi Metro SBI Card', country: 'IN', charges: [] },
  'sbi-fabindia-in': { id: 'sbi-fabindia-in', slug: 'sbi-fabindia-in', name: 'Fabindia SBI Card', country: 'IN', charges: [] },
  'sbi-shaurya-select-in': { id: 'sbi-shaurya-select-in', slug: 'sbi-shaurya-select-in', name: 'SBI Shaurya Select Card', country: 'IN', charges: [] },
  'sbi-doctors-in': { id: 'sbi-doctors-in', slug: 'sbi-doctors-in', name: 'Doctor\'s SBI Card', country: 'IN', charges: [] },
  'sbi-lifestyle-home-centre-in': { id: 'sbi-lifestyle-home-centre-in', slug: 'sbi-lifestyle-home-centre-in', name: 'Lifestyle Home Centre SBI Card', country: 'IN', charges: [] },
  'icici-sapphiro-in': { id: 'icici-sapphiro-in', slug: 'icici-sapphiro-in', name: 'ICICI Bank Sapphiro Credit Card', country: 'IN', charges: [] },
  'icici-rubyx-in': { id: 'icici-rubyx-in', slug: 'icici-rubyx-in', name: 'ICICI Bank Rubyx Credit Card', country: 'IN', charges: [] },
  'icici-emeralde-private-in': { id: 'icici-emeralde-private-in', slug: 'icici-emeralde-private-in', name: 'ICICI Bank Emeralde Private Credit Card', country: 'IN', charges: [] },
  'icici-coral-in': { id: 'icici-coral-in', slug: 'icici-coral-in', name: 'ICICI Bank Coral Credit Card', country: 'IN', charges: [] },
  'icici-hpcl-super-saver-in': { id: 'icici-hpcl-super-saver-in', slug: 'icici-hpcl-super-saver-in', name: 'ICICI Bank HPCL Super Saver Credit Card', country: 'IN', charges: [] },
  'icici-makemytrip-signature-in': { id: 'icici-makemytrip-signature-in', slug: 'icici-makemytrip-signature-in', name: 'MakeMyTrip ICICI Bank Signature Credit Card', country: 'IN', charges: [] },
  'icici-manchester-united-signature-in': { id: 'icici-manchester-united-signature-in', slug: 'icici-manchester-united-signature-in', name: 'Manchester United ICICI Bank Signature Credit Card', country: 'IN', charges: [] },
  'icici-expression-in': { id: 'icici-expression-in', slug: 'icici-expression-in', name: 'ICICI Bank Expression Credit Card', country: 'IN', charges: [] },
  'icici-mine-in': { id: 'icici-mine-in', slug: 'icici-mine-in', name: 'ICICI Bank MINE Credit Card', country: 'IN', charges: [] },
  'icici-unifarm-in': { id: 'icici-unifarm-in', slug: 'icici-unifarm-in', name: 'ICICI Bank Unifarm Credit Card', country: 'IN', charges: [] },
  'icici-accelero-in': { id: 'icici-accelero-in', slug: 'icici-accelero-in', name: 'ICICI Bank Accelero Credit Card', country: 'IN', charges: [] },
  'icici-chennai-super-kings-in': { id: 'icici-chennai-super-kings-in', slug: 'icici-chennai-super-kings-in', name: 'Chennai Super Kings ICICI Bank Credit Card', country: 'IN', charges: [] },
  'icici-business-advantage-black-in': { id: 'icici-business-advantage-black-in', slug: 'icici-business-advantage-black-in', name: 'ICICI Bank Business Advantage Black Card', country: 'IN', charges: [] },
  'icici-intermiles-sapphiro-in': { id: 'icici-intermiles-sapphiro-in', slug: 'icici-intermiles-sapphiro-in', name: 'InterMiles ICICI Bank Sapphiro Credit Card', country: 'IN', charges: [] },
  'icici-hpcl-coral-in': { id: 'icici-hpcl-coral-in', slug: 'icici-hpcl-coral-in', name: 'ICICI Bank HPCL Coral Credit Card', country: 'IN', charges: [] },
  'axis-magnus-in': { id: 'axis-magnus-in', slug: 'axis-magnus-in', name: 'Axis Bank Magnus Credit Card', country: 'IN', charges: [] },
  'axis-reserve-in': { id: 'axis-reserve-in', slug: 'axis-reserve-in', name: 'Axis Bank Reserve Credit Card', country: 'IN', charges: [] },
  'axis-atlas-in': { id: 'axis-atlas-in', slug: 'axis-atlas-in', name: 'Axis Bank Atlas Credit Card', country: 'IN', charges: [] },
  'axis-select-in': { id: 'axis-select-in', slug: 'axis-select-in', name: 'Axis Bank Select Credit Card', country: 'IN', charges: [] },
  'axis-vistara-infinite-in': { id: 'axis-vistara-infinite-in', slug: 'axis-vistara-infinite-in', name: 'Axis Bank Vistara Infinite Credit Card', country: 'IN', charges: [] },
  'axis-my-zone-in': { id: 'axis-my-zone-in', slug: 'axis-my-zone-in', name: 'Axis Bank My Zone Credit Card', country: 'IN', charges: [] },
  'axis-neo-in': { id: 'axis-neo-in', slug: 'axis-neo-in', name: 'Axis Bank Neo Credit Card', country: 'IN', charges: [] },
  'axis-kiwi-in': { id: 'axis-kiwi-in', slug: 'axis-kiwi-in', name: 'Kiwi Axis Bank Credit Card', country: 'IN', charges: [] },
  'axis-privilege-in': { id: 'axis-privilege-in', slug: 'axis-privilege-in', name: 'Axis Bank Privilege Credit Card', country: 'IN', charges: [] },
  'axis-indian-oil-in': { id: 'axis-indian-oil-in', slug: 'axis-indian-oil-in', name: 'IndianOil Axis Bank Credit Card', country: 'IN', charges: [] },
  'axis-samsung-infinite-in': { id: 'axis-samsung-infinite-in', slug: 'axis-samsung-infinite-in', name: 'Samsung Axis Bank Infinite Credit Card', country: 'IN', charges: [] },
  'axis-spicejet-voyage-black-in': { id: 'axis-spicejet-voyage-black-in', slug: 'axis-spicejet-voyage-black-in', name: 'SpiceJet Axis Bank Voyage Black Credit Card', country: 'IN', charges: [] },
  'axis-freecharge-in': { id: 'axis-freecharge-in', slug: 'axis-freecharge-in', name: 'Freecharge Axis Bank Credit Card', country: 'IN', charges: [] },
  'axis-airtel-in': { id: 'axis-airtel-in', slug: 'axis-airtel-in', name: 'Airtel Axis Bank Credit Card', country: 'IN', charges: [] },
  'axis-pride-signature-in': { id: 'axis-pride-signature-in', slug: 'axis-pride-signature-in', name: 'Axis Bank Pride Signature Credit Card', country: 'IN', charges: [] },
  'kotak-league-platinum-in': { id: 'kotak-league-platinum-in', slug: 'kotak-league-platinum-in', name: 'Kotak League Platinum Credit Card', country: 'IN', charges: [] },
  'kotak-mojo-platinum-in': { id: 'kotak-mojo-platinum-in', slug: 'kotak-mojo-platinum-in', name: 'Kotak Mojo Platinum Credit Card', country: 'IN', charges: [] },
  'kotak-zen-signature-in': { id: 'kotak-zen-signature-in', slug: 'kotak-zen-signature-in', name: 'Kotak Zen Signature Credit Card', country: 'IN', charges: [] },
  'kotak-white-reserve-in': { id: 'kotak-white-reserve-in', slug: 'kotak-white-reserve-in', name: 'Kotak White Reserve Credit Card', country: 'IN', charges: [] },
  'kotak-pvr-platinum-in': { id: 'kotak-pvr-platinum-in', slug: 'kotak-pvr-platinum-in', name: 'Kotak PVR Platinum Credit Card', country: 'IN', charges: [] },
  'kotak-indian-oil-in': { id: 'kotak-indian-oil-in', slug: 'kotak-indian-oil-in', name: 'IndianOil Kotak Credit Card', country: 'IN', charges: [] },
  'kotak-811-dream-different-in': { id: 'kotak-811-dream-different-in', slug: 'kotak-811-dream-different-in', name: 'Kotak 811 #DreamDifferent Credit Card', country: 'IN', charges: [] },
  'amex-platinum-charge-in': { id: 'amex-platinum-charge-in', slug: 'amex-platinum-charge-in', name: 'American Express Platinum Charge Card', country: 'IN', charges: [] },
  'amex-gold-charge-in': { id: 'amex-gold-charge-in', slug: 'amex-gold-charge-in', name: 'American Express Gold Charge Card', country: 'IN', charges: [] },
  'amex-smartearn-in': { id: 'amex-smartearn-in', slug: 'amex-smartearn-in', name: 'American Express SmartEarn™ Credit Card', country: 'IN', charges: [] },
  'amex-platinum-travel-in': { id: 'amex-platinum-travel-in', slug: 'amex-platinum-travel-in', name: 'American Express Platinum Travel Credit Card', country: 'IN', charges: [] },
  'idfc-first-millennia-in': { id: 'idfc-first-millennia-in', slug: 'idfc-first-millennia-in', name: 'IDFC FIRST Millennia Credit Card', country: 'IN', charges: [] },
  'idfc-first-wealth-in': { id: 'idfc-first-wealth-in', slug: 'idfc-first-wealth-in', name: 'IDFC FIRST Wealth Credit Card', country: 'IN', charges: [] },
  'idfc-first-select-in': { id: 'idfc-first-select-in', slug: 'idfc-first-select-in', name: 'IDFC FIRST Select Credit Card', country: 'IN', charges: [] },
  'rbl-world-safari-in': { id: 'rbl-world-safari-in', slug: 'rbl-world-safari-in', name: 'RBL World Safari Credit Card', country: 'IN', charges: [] },
  'rbl-bookmyshow-play-in': { id: 'rbl-bookmyshow-play-in', slug: 'rbl-bookmyshow-play-in', name: 'BookMyShow RBL Bank Play Credit Card', country: 'IN', charges: [] },
  'rbl-shoprite-in': { id: 'rbl-shoprite-in', slug: 'rbl-shoprite-in', name: 'RBL Shoprite Credit Card', country: 'IN', charges: [] },
  'indusind-legend-in': { id: 'indusind-legend-in', slug: 'indusind-legend-in', name: 'IndusInd Bank Legend Credit Card', country: 'IN', charges: [] },
  'indusind-pinnacle-in': { id: 'indusind-pinnacle-in', slug: 'indusind-pinnacle-in', name: 'IndusInd Bank Pinnacle Credit Card', country: 'IN', charges: [] },
  'indusind-eazydiner-in': { id: 'indusind-eazydiner-in', slug: 'indusind-eazydiner-in', name: 'EazyDiner IndusInd Bank Credit Card', country: 'IN', charges: [] },
  'bob-eterna-in': { id: 'bob-eterna-in', slug: 'bob-eterna-in', name: 'Bank of Baroda Eterna Credit Card', country: 'IN', charges: [] },
  'bob-premier-in': { id: 'bob-premier-in', slug: 'bob-premier-in', name: 'Bank of Baroda Premier Credit Card', country: 'IN', charges: [] },
  'sc-ultimate-in': { id: 'sc-ultimate-in', slug: 'sc-ultimate-in', name: 'Standard Chartered Ultimate Credit Card', country: 'IN', charges: [] },
  'sc-smart-in': { id: 'sc-smart-in', slug: 'sc-smart-in', name: 'Standard Chartered Smart Credit Card', country: 'IN', charges: [] },
  'citi-premiermiles-in': { id: 'citi-premiermiles-in', slug: 'citi-premiermiles-in', name: 'Citi PremierMiles Credit Card', country: 'IN', charges: [] },
  'citi-rewards-in': { id: 'citi-rewards-in', slug: 'citi-rewards-in', name: 'Citi Rewards Credit Card', country: 'IN', charges: [] },
  'yes-first-exclusive-in': { id: 'yes-first-exclusive-in', slug: 'yes-first-exclusive-in', name: 'YES FIRST Exclusive Credit Card', country: 'IN', charges: [] },
  'yes-prosperity-edge-in': { id: 'yes-prosperity-edge-in', slug: 'yes-prosperity-edge-in', name: 'YES Prosperity Edge Credit Card', country: 'IN', charges: [] },

  // == United States ==
  'chase-sapphire-preferred-us': { id: 'chase-sapphire-preferred-us', slug: 'chase-sapphire-preferred-us', name: 'Chase Sapphire Preferred® Card', country: 'US', charges: [] },
  'amex-platinum-us': { id: 'amex-platinum-us', slug: 'amex-platinum-us', name: 'The Platinum Card® from American Express', country: 'US', charges: [] },
  'capital-one-venture-x-us': { id: 'capital-one-venture-x-us', slug: 'capital-one-venture-x-us', name: 'Capital One Venture X Rewards Card', country: 'US', charges: [] },
  'citi-double-cash-us': { id: 'citi-double-cash-us', slug: 'citi-double-cash-us', name: 'Citi® Double Cash Card', country: 'US', charges: [] },
  'discover-it-cash-back-us': { id: 'discover-it-cash-back-us', slug: 'discover-it-cash-back-us', name: 'Discover it® Cash Back', country: 'US', charges: [] },

  // == United Kingdom ==
  'amex-preferred-rewards-gold-gb': { id: 'amex-gold-gb', slug: 'amex-preferred-rewards-gold-gb', name: 'American Express Preferred Rewards Gold Credit Card', country: 'GB', charges: [] },
  'barclaycard-rewards-gb': { id: 'barclaycard-rewards-gb', slug: 'barclaycard-rewards-gb', name: 'Barclaycard Rewards Credit Card', country: 'GB', charges: [] },
  'virgin-atlantic-rewards-plus-gb': { id: 'virgin-atlantic-plus-gb', slug: 'virgin-atlantic-rewards-plus-gb', name: 'Virgin Atlantic Rewards+ Credit Card', country: 'GB', charges: [] },

  // == Australia ==
  'qantas-premier-platinum-au': { id: 'qantas-premier-platinum-au', slug: 'qantas-premier-platinum-au', name: 'Qantas Premier Platinum', country: 'AU', charges: [] },
  'amex-explorer-au': { id: 'amex-explorer-au', slug: 'amex-explorer-au', name: 'American Express Explorer Card', country: 'AU', charges: [] },
  'commbank-ultimate-awards-au': { id: 'commbank-ultimate-awards-au', slug: 'commbank-ultimate-awards-au', name: 'CommBank Ultimate Awards Card', country: 'AU', charges: [] },

  // == Canada ==
  'scotia-gold-amex-ca': { id: 'scotia-gold-amex-ca', slug: 'scotia-gold-amex-ca', name: 'Scotiabank Gold American Express Card', country: 'CA', charges: [] },
  'td-aeroplan-visa-infinite-ca': { id: 'td-aeroplan-visa-infinite-ca', slug: 'td-aeroplan-visa-infinite-ca', name: 'TD® Aeroplan® Visa Infinite* Card', country: 'CA', charges: [] },
  'amex-cobalt-ca': { id: 'amex-cobalt-ca', slug: 'amex-cobalt-ca', name: 'American Express Cobalt Card', country: 'CA', charges: [] },

  // == Singapore ==
  'uob-evol-sg': { id: 'uob-evol-sg', slug: 'uob-evol-sg', name: 'UOB EVOL Card', country: 'SG', charges: [] },
  'dbs-live-fresh-sg': { id: 'dbs-live-fresh-sg', slug: 'dbs-live-fresh-sg', name: 'DBS Live Fresh Card', country: 'SG', charges: [] },
  'citi-rewards-sg': { id: 'citi-rewards-sg', slug: 'citi-rewards-sg', name: 'Citi Rewards Card', country: 'SG', charges: [] },
  'uob-one-card-sg': { id: 'uob-one-card-sg', slug: 'uob-one-card-sg', name: 'UOB One Card', country: 'SG', charges: [] },
  'dbs-altitude-visa-sg': { id: 'dbs-altitude-visa-sg', slug: 'dbs-altitude-visa-sg', name: 'DBS Altitude Visa Signature Card', country: 'SG', charges: [] },
  'ocbc-365-card-sg': { id: 'ocbc-365-card-sg', slug: 'ocbc-365-card-sg', name: 'OCBC 365 Credit Card', country: 'SG', charges: [] },
  'citi-premiermiles-sg': { id: 'citi-premiermiles-sg', slug: 'citi-premiermiles-sg', name: 'Citi PremierMiles Card', country: 'SG', charges: [] },
  'sc-smart-card-sg': { id: 'sc-smart-card-sg', slug: 'sc-smart-card-sg', name: 'Standard Chartered Smart Credit Card', country: 'SG', charges: [] },
  'amex-krisflyer-sg': { id: 'amex-krisflyer-sg', slug: 'amex-krisflyer-sg', name: 'American Express Singapore Airlines KrisFlyer Credit Card', country: 'SG', charges: [] },
  'maybank-family-friends-sg': { id: 'maybank-family-friends-sg', slug: 'maybank-family-friends-sg', name: 'Maybank Family & Friends Card', country: 'SG', charges: [] },
  'hsbc-revolution-card-sg': { id: 'hsbc-revolution-card-sg', slug: 'hsbc-revolution-card-sg', name: 'HSBC Revolution Credit Card', country: 'SG', charges: [] },
  'cimb-visa-signature-sg': { id: 'cimb-visa-signature-sg', slug: 'cimb-visa-signature-sg', name: 'CIMB Visa Signature', country: 'SG', charges: [] },
  'uob-prvi-miles-sg': { id: 'uob-prvi-miles-sg', slug: 'uob-prvi-miles-sg', name: 'UOB PRVI Miles Card', country: 'SG', charges: [] },
  'dbs-womans-world-sg': { id: 'dbs-womans-world-sg', slug: 'dbs-womans-world-sg', name: 'DBS Woman\'s World Card', country: 'SG', charges: [] },
  'ocbc-frank-card-sg': { id: 'ocbc-frank-card-sg', slug: 'ocbc-frank-card-sg', name: 'OCBC FRANK Credit Card', country: 'SG', charges: [] },
  'citi-cash-back-plus-sg': { id: 'citi-cash-back-plus-sg', slug: 'citi-cash-back-plus-sg', name: 'Citi Cash Back+ Card', country: 'SG', charges: [] },
  'sc-journey-card-sg': { id: 'sc-journey-card-sg', slug: 'sc-journey-card-sg', name: 'Standard Chartered Journey Credit Card', country: 'SG', charges: [] },
  'amex-platinum-card-sg': { id: 'amex-platinum-card-sg', slug: 'amex-platinum-card-sg', name: 'The Platinum Card from American Express', country: 'SG', charges: [] },
  'uob-absolute-cashback-sg': { id: 'uob-absolute-cashback-sg', slug: 'uob-absolute-cashback-sg', name: 'UOB Absolute Cashback Card', country: 'SG', charges: [] },
  'dbs-takashimaya-amex-sg': { id: 'dbs-takashimaya-amex-sg', slug: 'dbs-takashimaya-amex-sg', name: 'DBS Takashimaya American Express Card', country: 'SG', charges: [] },
  'ocbc-titanium-rewards-sg': { id: 'ocbc-titanium-rewards-sg', slug: 'ocbc-titanium-rewards-sg', name: 'OCBC Titanium Rewards Card', country: 'SG', charges: [] },
  'citi-lazada-card-sg': { id: 'citi-lazada-card-sg', slug: 'citi-lazada-card-sg', name: 'Citi Lazada Credit Card', country: 'SG', charges: [] },
  'hsbc-visa-infinite-sg': { id: 'hsbc-visa-infinite-sg', slug: 'hsbc-visa-infinite-sg', name: 'HSBC Visa Infinite Credit Card', country: 'SG', charges: [] },
  'maybank-horizon-visa-sg': { id: 'maybank-horizon-visa-sg', slug: 'maybank-horizon-visa-sg', name: 'Maybank Horizon Visa Signature', country: 'SG', charges: [] },
  'uob-krisflyer-card-sg': { id: 'uob-krisflyer-card-sg', slug: 'uob-krisflyer-card-sg', name: 'KrisFlyer UOB Credit Card', country: 'SG', charges: [] },
  'dbs-vantage-visa-infinite-sg': { id: 'dbs-vantage-visa-infinite-sg', slug: 'dbs-vantage-visa-infinite-sg', name: 'DBS Vantage Visa Infinite Card', country: 'SG', charges: [] },
  'ocbc-90n-card-sg': { id: 'ocbc-90n-card-sg', slug: 'ocbc-90n-card-sg', name: 'OCBC 90°N Card', country: 'SG', charges: [] },
  'citi-prestige-card-sg': { id: 'citi-prestige-card-sg', slug: 'citi-prestige-card-sg', name: 'Citi Prestige Card', country: 'SG', charges: [] },
  'sc-bonusaver-card-sg': { id: 'sc-bonusaver-card-sg', slug: 'sc-bonusaver-card-sg', name: 'Standard Chartered Bonus$aver Credit Card', country: 'SG', charges: [] },
  'amex-capitacard-sg': { id: 'amex-capitacard-sg', slug: 'amex-capitacard-sg', name: 'American Express CapitaCard', country: 'SG', charges: [] },
  'cimb-world-mastercard-sg': { id: 'cimb-world-mastercard-sg', slug: 'cimb-world-mastercard-sg', name: 'CIMB World Mastercard', country: 'SG', charges: [] },
  'hsbc-advance-card-sg': { id: 'hsbc-advance-card-sg', slug: 'hsbc-advance-card-sg', name: 'HSBC Advance Credit Card', country: 'SG', charges: [] },
  'maybank-platinum-visa-sg': { id: 'maybank-platinum-visa-sg', slug: 'maybank-platinum-visa-sg', name: 'Maybank Platinum Visa Card', country: 'SG', charges: [] },
};
